/* Holtmore neutral PDP — Claude preview build 01.10.2026 (+04.10.: market date format, gallery preload; +05.10.: ships-by date, no arrival date). Demo buy box (no checkout), gallery, drawer, sticky ATC, countdown. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hmc]');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  if (/[?&]review=1(&|$)/.test(location.search)) document.documentElement.classList.add('hmc-review');

  /* toast */
  var toastEl = $('[data-hmc-toast]'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg || 'Preview — checkout connects at launch';
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2200);
  }

  /* offers */
  var cards = $$('.hmc-offer', root), atc = $('#hmcAtc'), stBtn = $('[data-st-btn]'), stQty = $('[data-st-qty]'), stPrice = $('[data-st-price]'), stDay = $('[data-st-day]');
  function selectOffer(v) {
    var card = null;
    cards.forEach(function (c) {
      var on = c.getAttribute('data-offer') === v;
      c.classList.toggle('is-sel', on);
      var inp = $('input', c); if (inp) inp.checked = on;
      if (on) card = c;
    });
    if (!card) return;
    if (atc) atc.textContent = card.getAttribute('data-atc');
    if (stBtn) stBtn.textContent = card.getAttribute('data-st');
    if (stQty) stQty.textContent = card.getAttribute('data-qty');
    if (stPrice) stPrice.textContent = card.getAttribute('data-price');
    if (stDay) stDay.textContent = card.getAttribute('data-day');
  }
  cards.forEach(function (c) {
    var inp = $('input', c);
    if (inp) inp.addEventListener('change', function () { selectOffer(c.getAttribute('data-offer')); });
  });
  /* ?hm_offer=b2g2|b1g1|one (links from home + science) preselects that offer; default B2G2 */
  var hmOff = { b2g2: '4', b1g1: '2', one: '1' }[new URLSearchParams(location.search).get('hm_offer')] || '4';
  selectOffer(hmOff);

  function scrollToEl(el, off) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - (off || 90);
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* drawer */
  var drawer = $('[data-hmc-drawer]'), dbg = $('.hmc-drawer-bg', root);
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); dbg.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); dbg.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* delegated clicks */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toast],[data-buy],[data-open-drawer],[data-close-drawer],[data-faq],[data-jump],[data-gal]');
    if (!t) return;
    if (t.hasAttribute('data-close-drawer')) closeDrawer();
    if (t.hasAttribute('data-open-drawer')) { openDrawer(); return; }
    if (t.hasAttribute('data-buy')) {
      var v = t.getAttribute('data-buy');
      if (v !== 'keep') selectOffer(v);
      setTimeout(function () { scrollToEl($('#hmc-s9')); }, t.hasAttribute('data-close-drawer') ? 280 : 0);
      return;
    }
    if (t.hasAttribute('data-toast')) { toast(t.getAttribute('data-toast')); return; }
    if (t.hasAttribute('data-faq')) {
      var d = $('#hmc-faq' + t.getAttribute('data-faq'));
      if (d) { d.open = true; scrollToEl(d); }
      return;
    }
    if (t.hasAttribute('data-jump')) { scrollToEl($('#' + t.getAttribute('data-jump'))); return; }
    if (t.hasAttribute('data-gal')) goSlide(cur + parseInt(t.getAttribute('data-gal'), 10));
  });

  /* gallery */
  var main = $('[data-hmc-gal-main]'), slides = main ? $$('.hmc-gal__slide', main) : [], thumbs = $$('[data-hmc-gal-thumbs] button'), cnt = $('[data-hmc-gal-count]'), tot = $('[data-hmc-gal-total]'), note = $('[data-hmc-gal-note]'), cur = 0;
  if (tot) tot.textContent = slides.length;
  /* gallery images are loading=lazy inside a horizontal scroller: load the next two slides before the swipe gets there */
  function warm(i) {
    [i, i + 1, i + 2].forEach(function (k) {
      var sl = slides[k], im = sl && sl.querySelector('img[loading="lazy"]');
      if (im) im.loading = 'eager';
    });
  }
  function markSlide(i) {
    cur = i;
    warm(i);
    thumbs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
    if (cnt) cnt.textContent = i + 1;
    if (note) note.textContent = slides[i] ? (slides[i].getAttribute('data-note') || '') : '';
    var tb = thumbs[i], strip = tb && tb.parentNode;
    if (tb && strip) strip.scrollTo({ left: tb.offsetLeft - strip.clientWidth / 2 + 28, behavior: 'smooth' });
  }
  function goSlide(i) {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' });
    markSlide(i);
  }
  thumbs.forEach(function (b, i) { b.addEventListener('click', function () { goSlide(i); }); });
  if (main) {
    var galT;
    main.addEventListener('scroll', function () {
      clearTimeout(galT);
      galT = setTimeout(function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        if (i !== cur) markSlide(i);
      }, 80);
    }, { passive: true });
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goSlide(cur + 1);
      if (e.key === 'ArrowLeft') goSlide(cur - 1);
    });
    markSlide(0);
    /* thumbs are tiny (140px): load them all once the page is done */
    window.addEventListener('load', function () {
      setTimeout(function () { thumbs.forEach(function (b) { var im = b.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; }); }, 800);
    });
  }

  /* countdown to local midnight */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var hms = $$('[data-countdown="hms"]'), hm = $$('[data-countdown="hm"]');
  function tick() {
    var now = new Date(), mid = new Date(now); mid.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((mid - now) / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    hms.forEach(function (el) { el.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec); });
    hm.forEach(function (el) { el.textContent = pad(h) + ':' + pad(m); });
  }
  tick(); setInterval(tick, 1000);

  /* ships by (Mark 05.10.): today + N business days, Sat/Sun skipped (N = section setting ship_days, default 2) */
  (function () {
    var els = $$('[data-hmc-ship]'); if (!els.length) return;
    var n = parseInt(root.getAttribute('data-ship-days'), 10) || 2;
    var d = new Date(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var mons = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    /* US/CA "Wed, Oct 7" · GB/IE/AU/NZ "Wednesday 7 October" (data-date-fmt from the market layer) */
    var txt = root.getAttribute('data-date-fmt') === 'dmy'
      ? days[d.getDay()] + ' ' + d.getDate() + ' ' + mons[d.getMonth()]
      : days[d.getDay()].slice(0, 3) + ', ' + mons[d.getMonth()].slice(0, 3) + ' ' + d.getDate();
    els.forEach(function (el) { el.textContent = txt; });
  })();

  /* sticky ATC: after the main button scrolled away, hidden near footer */
  var sticky = $('[data-hmc-sticky]'), footer = document.querySelector('.hmc-ftr');
  function onScroll() {
    if (!sticky || !atc) return;
    var a = atc.getBoundingClientRect(), vh = window.innerHeight;
    var f = footer ? footer.getBoundingClientRect().top : 1e9;
    var show = a.bottom < 0 && f > vh - 40;
    sticky.classList.toggle('is-show', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* footer: newsletter demo + country switch */
  $$('[data-hmc-newsletter]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); if (!f.reportValidity()) return; toast('Preview — no email saved'); });
  });
  $$('[data-hmc-loc]').forEach(function (s) { s.addEventListener('change', function () { if (s.form) s.form.submit(); }); });
})();
